
import React from 'react'
import SubscribeEmaillistTable from './Components/SubscribeEmaillistTable'
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const SubscribeEmaillist = () => {
  return (
    <PageBody
     card={true}
     headerchildren={
        <HeadingOne>Subscriber List</HeadingOne>
     }>

      <div className="col-12">
        <SubscribeEmaillistTable />
      </div>
    </PageBody>
  );
};

export default SubscribeEmaillist;
